<template>
  <div class="home">
    <div class="content">
      <div class="logo-container">
        <img src="@/assets/images/img-home-logo.png" alt="Logo" class="logo-image" />
      </div>
      <div class="title">AI一键生成标准</div>
      <div class="subtitle-container">
        <p class="subtitle">输入你的核心思想，让AI为你一站式服务到底</p>
      </div>
      <el-button type="primary" class="start-button" round @click="startUsingApp">开始生成标准</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomePage',
  methods: {
    startUsingApp() {
      // 检查用户是否已登录
      const token = localStorage.getItem('token');
      if (!token) {
        // 未登录，将目标路径保存到localStorage，然后跳转到登录页面
        localStorage.setItem('redirectPath', '/chat');
        this.$router.push('/login');
      } else {
        // 已登录，跳转到Chat页面
        this.$router.push('/chat');
      }
    }
  }
}
</script>

<style scoped>
.home {
  min-height: 100vh;
  padding: 20px;
  background-color: #f5f7fa;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  background-image: url('@/assets/images/img-home-bg.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  max-width: 800px;
  margin: 0 auto;
  padding-bottom: 5vh;
  position: relative;
  z-index: 1;
  transform: translateY(-8vh);
  /* 向上移动整体内容 */
}

.logo-container {
  margin-bottom: 70px;
  transform: scale(1);
  transition: transform 0.3s ease;
}

.logo-container:hover {
  transform: scale(1.1);
}

.logo-image {
  width: 225px;
  height: auto;
}

.title {
  margin-bottom: 32px;
  font-family: AlimamaFangYuanTiVF, AlimamaFangYuanTiVF;
  font-weight: bold;
  font-size: 40px;
  color: #222222;
  line-height: 48px;
  text-align: center;
  font-style: normal;
}

.subtitle-container {
  margin-bottom: 120px;
  white-space: nowrap;
}

.subtitle {
  font-family: AlimamaFangYuanTiVF, AlimamaFangYuanTiVF;
  font-weight: 400;
  font-size: 16px;
  color: #222222;
  line-height: 19px;
  text-align: center;
  font-style: normal;
}

.start-button {
  width: 227px;
  height: 74px;
  background: linear-gradient(270deg, #8F9EFF 0%, #4E1AD6 100%);
  box-shadow: inset 0px 0 21px 0px rgba(255, 250, 250, 0.5);
  border-radius: 43px;
  font-family: AlimamaFangYuanTiVF, AlimamaFangYuanTiVF;
  font-weight: 600;
  font-size: 25px;
  color: #FFFFFF;
  line-height: 30px;
  text-align: center;
  font-style: normal;
  border: none;
}

.start-button:hover {
  transform: translateY(-2px);
}
</style>